import React, { useRef } from 'react'
import {
  Button, Dropdown, Menu, Row, Col,
} from 'antd'
import {
  DownOutlined, LeftOutlined, RightOutlined,
} from '@ant-design/icons'

import { useScroll } from 'ahooks'
import { useIsSmallDevice } from '../../hookreducer/hooks'

import __ from '../../languages/parser'

// import { BOARD_URL } from '../../static/url'

import RecapMenu from './RecapMenu'

const MENU_STYLE = { zIndex: 10000 }

const BoardsMenuSmall = ({
  addElement,
}) => {
  const ref = useRef(null)
  const { left } = useScroll(ref)
  const maxScroll = ref.current ? ref.current.scrollWidth - ref.current.clientWidth : null

  const scrollLimit = left === 0 ? 'left' : left >= maxScroll - 1 ? 'right' : 'both'
  const setScroll = (direction) => {
    const stepScroll = direction === 'right' ? 100 : -100
    ref.current.scrollLeft += stepScroll
  }

  const SIZE = 'default'
  const MARGIN_BUTTON = '6px'
  const blocStyle = {
    display: 'flex',
    flexDirection: 'column',
    marginRight: '10px',
    maxHeight: '84px',
    borderRadius: '12px',
    fontSize: '0.8em',
  }

  const blocStyleButtons = {
    marginTop: '4px',
    display: 'flex',
    flexDirection: 'row',
  }
  const hooks6030 = (
    <Menu onClick={(k) => addElement(k.key)}>
      <Menu.Item key="board60x30_t2">{__('Small Support brackets')}</Menu.Item>
      <Menu.Item key="board60x30_t3">{__('Big Support brackets')}</Menu.Item>
    </Menu>
  )

  const hooks8030 = (
    <Menu onClick={(k) => addElement(k.key)}>
      <Menu.Item key="board80x30_t2">{__('Small Support brackets')}</Menu.Item>
      <Menu.Item key="board80x30_t3">{__('Big Support brackets')}</Menu.Item>
    </Menu>
  )

  return (
    <Row>

      <Col span={1} style={{ fontSize: '0.8em', color: '#AAAAAA', lineHeight: '32px' }}>
        {scrollLimit === 'left' ? null
          : (
            <Button
              block
              type="text"
              size="small"
              style={{
                padding: 0, margin: 0, border: 'none', backgroundColor: 'none',
              }}
              onClick={() => setScroll('left')}
            >
              <LeftOutlined style={{ position: 'relative', top: '26px' }} />
            </Button>
          )}

      </Col>

      <Col offset={1} span={20}>
        <div
          style={{
            overflowX: 'scroll',
            overflowY: 'hidden',
            display: 'flex',
            flexDirection: 'row',
            paddingBottom: '10px',
            height: '74px',
          }}
          ref={ref}
        >

          <div style={blocStyle}>
            <div>
              {__('Length')}
              {' '}
              40cm
            </div>
            <div style={blocStyleButtons}>
              <Button size={SIZE} onClick={() => addElement('board40x15')} style={{ marginRight: MARGIN_BUTTON }}>P.15cm</Button>
              <Button size={SIZE} onClick={() => addElement('board40x20')}>P.20cm</Button>
            </div>
          </div>

          <div style={blocStyle}>
            <div>
              {__('Length')}
              {' '}
              60cm
            </div>
            <div style={blocStyleButtons}>
              <Button size={SIZE} onClick={() => addElement('board60x15')} style={{ marginRight: MARGIN_BUTTON }}>P.15cm</Button>
              <Button size={SIZE} onClick={() => addElement('board60x20')} style={{ marginRight: MARGIN_BUTTON }}>P.20cm</Button>
              <Dropdown overlayStyle={MENU_STYLE} overlay={hooks6030}>
                <Button block size={SIZE}>
                  P.30cm
                  <DownOutlined />
                </Button>
              </Dropdown>
            </div>
          </div>

          <div style={blocStyle}>
            <div>
              {__('Length')}
              {' '}
              80cm
            </div>
            <div style={blocStyleButtons}>
              <Button size={SIZE} onClick={() => addElement('board80x15')} style={{ marginRight: MARGIN_BUTTON }}>P.15cm</Button>
              <Button size={SIZE} onClick={() => addElement('board80x20')} style={{ marginRight: MARGIN_BUTTON }}>P.20cm</Button>
              <Dropdown overlayStyle={MENU_STYLE} overlay={hooks8030}>
                <Button block size={SIZE}>
                  L.80 x P.30cm
                  <DownOutlined />
                </Button>
              </Dropdown>
            </div>
          </div>

          <div style={blocStyle}>
            <div>
              {__('Desk')}
            </div>
            <div style={blocStyleButtons}>
              <Button size={SIZE} onClick={() => addElement('desk60x50')} style={{ marginRight: MARGIN_BUTTON }}>L.60 x P.50cm</Button>
            </div>
            <div style={blocStyleButtons}>
              <Button size={SIZE} onClick={() => addElement('desk80x50')}>L.80 x P.50cm</Button>
            </div>

          </div>

        </div>

      </Col>
      <Col offset={1} span={1} style={{ fontSize: '0.8em', color: '#AAAAAA', lineHeight: '32px' }}>
        {scrollLimit === 'right' ? null
          : (
            <Button
              block
              type="text"
              size="small"
              style={{
                padding: 0, margin: 0, border: 'none', backgroundColor: 'none',
              }}
              onClick={() => setScroll('right')}
            >
              <RightOutlined style={{ position: 'relative', top: '26px' }} />
            </Button>
          )}
      </Col>
    </Row>
  )
}

const BoardsMenu = ({
  addElement, setTag, isTagged, setQuotes, isQuotes,
  metalColor, woodColor, setMetalColor, setWoodColor,
}) => {
  const SIZE = 'default'

  const boardStyle = {
    marginBottom: '0.4em',
  }

  const hooks6030 = (
    <Menu onClick={(k) => addElement(k.key)}>
      <Menu.Item key="board60x30_t2">{__('Small Support brackets')}</Menu.Item>
      <Menu.Item key="board60x30_t3">{__('Big Support brackets')}</Menu.Item>
    </Menu>
  )

  const hooks8030 = (
    <Menu onClick={(k) => addElement(k.key)}>
      <Menu.Item key="board80x30_t2">{__('Small Support brackets')}</Menu.Item>
      <Menu.Item key="board80x30_t3">{__('Big Support brackets')}</Menu.Item>
    </Menu>
  )

  return (
    <>
      <div className="maker-subtitle">
        {__('Boards')}
        {' '}
        L.40cm
      </div>

      <Button size={SIZE} style={boardStyle} block onClick={() => addElement('board40x15')}>L.40 x P.15cm</Button>


      <Button size={SIZE} style={boardStyle} block onClick={() => addElement('board40x20')}>L.40 x P.20cm</Button>

      <div className="maker-subtitle" style={{ marginTop: '1em' }}>
        {__('Boards')}
        {' '}
        L.60cm
      </div>
      <Button size={SIZE} style={boardStyle} block onClick={() => addElement('board60x15')}>L.60 x P.15cm</Button>
      <Button size={SIZE} style={boardStyle} block onClick={() => addElement('board60x20')}>L.60 x P.20cm</Button>
      <Dropdown overlayStyle={MENU_STYLE} overlay={hooks6030}>
        <Button block size={SIZE} style={boardStyle}>
          L.60 x P.30cm
          <DownOutlined />
        </Button>
      </Dropdown>

      <div className="maker-subtitle" style={{ marginTop: '1em' }}>
        {__('Boards')}
        {' '}
        L.80cm
      </div>
      <Button size={SIZE} style={boardStyle} block onClick={() => addElement('board80x15')}>L.80 x P.15cm</Button>
      <Button size={SIZE} style={boardStyle} block onClick={() => addElement('board80x20')}>L.80 x P.20cm</Button>
      <Dropdown overlayStyle={MENU_STYLE} overlay={hooks8030}>
        <Button style={boardStyle} block size={SIZE}>
          L.80 x P.30cm
          <DownOutlined />
        </Button>
      </Dropdown>
      <div className="maker-subtitle" style={{ marginTop: '1em' }}>
        {__('Desk')}
      </div>
      <Button size={SIZE} style={boardStyle} block onClick={() => addElement('desk60x50')}>{`${__('Desk')} L.60 x P.50cm`}</Button>
      <Button size={SIZE} style={boardStyle} block onClick={() => addElement('desk80x50')}>{`${__('Desk')} L.80 x P.50cm`}</Button>

      <RecapMenu
        setTag={setTag}
        isTagged={isTagged}
        setQuotes={setQuotes}
        isQuotes={isQuotes}
        metalColor={metalColor}
        woodColor={woodColor}
        setWoodColor={setWoodColor}
        setMetalColor={setMetalColor}
      />
    </>
  )
}

const BoardsMenuContainer = (props) => {
  const isSmall = useIsSmallDevice()
  return isSmall ? <BoardsMenuSmall {...props} /> : <BoardsMenu {...props} />
}

export default BoardsMenuContainer
